import { render } from "./QrVerifyPersonalId.vue?vue&type=template&id=2ea587f8"
import script from "./QrVerifyPersonalId.vue?vue&type=script&lang=js"
export * from "./QrVerifyPersonalId.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__